import { LayerType } from "../../types";
import { ConstraintsLayerType } from "../ConstraintsLayerType";
import { ConnectivityLayerSummary } from "./Summaries/ConnectivityLayerSummary";
import AmenitiesPrintable from "./AmenitiesPrintable";
import { AmenitiesLayerSummaryUK, AmenitiesLayerSummaryUS } from "./Summaries/AmenitiesLayerSummary";

export const AmenitiesLayerTypeUK: LayerType = {
  ...ConstraintsLayerType,
  Printable: AmenitiesPrintable,
  LayerSummary: AmenitiesLayerSummaryUK,
};

export const AmenitiesLayerTypeUS: LayerType = {
  ...ConstraintsLayerType,
  LayerSummary: AmenitiesLayerSummaryUS,
};

export const ConnectivitySummaryLayerType: LayerType = {
  LayerSummary: ConnectivityLayerSummary,
};
